import { c as _c } from "react/compiler-runtime";
import LinkComponent, { LinkComponentLink } from '../link/link.component';
import { MouseEvent, ReactElement, memo } from 'react';
import ImageComponent from '@spa/components/image-component/image.component';
import LayoutVariant from '@spa/components/mobile-icon-carousel/layout-variant';
import { Metadata } from '@spa/pages-converters/cms/component-envelops/CmsComponentEnvelopBase';
import classNames from 'clsx';
import styles from './mobile-icon-tile.component.module.scss';
import { tracker } from '@spa/lib/tracking/tracker';
export interface Icon {
  readonly src: string;
  readonly alt: string;
  readonly width: number;
  readonly height: number;
  readonly mimeType: string;
}
export interface Props {
  readonly icon: Icon;
  readonly layoutVariant: LayoutVariant;
  readonly link: LinkComponentLink | null;
  readonly text: string | null;
  readonly metadata: ReadonlyArray<Metadata>;
  readonly priority: boolean;
}
function MobileIconTile(t0) {
  const $ = _c(27);
  const {
    icon: t1,
    link,
    text,
    layoutVariant,
    priority
  } = t0;
  const {
    src,
    alt,
    height,
    width,
    mimeType
  } = t1;
  const t2 = layoutVariant === LayoutVariant.CIRCLED;
  let t3;
  if ($[0] !== t2) {
    t3 = classNames(styles["mobile-icon-tile"], {
      [styles["mobile-icon-tile--circled"]]: t2
    });
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const mobileIconTileClass = t3;
  const t4 = layoutVariant === LayoutVariant.CIRCLED;
  let t5;
  if ($[2] !== t4) {
    t5 = classNames(styles["mobile-icon-tile__icon-wrapper"], {
      [styles["mobile-icon-tile__icon-wrapper--circled"]]: t4
    });
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const iconWrapperClass = t5;
  const t6 = priority ? "high" : undefined;
  const t7 = `${alt} icon`;
  let t8;
  if ($[4] !== height || $[5] !== mimeType || $[6] !== priority || $[7] !== src || $[8] !== t6 || $[9] !== t7 || $[10] !== width) {
    t8 = <ImageComponent fetchPriority={t6} priority={priority} src={src} width={width} height={height} alt={t7} mimeType={mimeType} />;
    $[4] = height;
    $[5] = mimeType;
    $[6] = priority;
    $[7] = src;
    $[8] = t6;
    $[9] = t7;
    $[10] = width;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== iconWrapperClass || $[13] !== t8) {
    t9 = <div className={iconWrapperClass}>{t8}</div>;
    $[12] = iconWrapperClass;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== text) {
    t10 = text && <span className={styles["mobile-icon-tile__icon-text"]}>{text}</span>;
    $[15] = text;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== mobileIconTileClass || $[18] !== t10 || $[19] !== t9) {
    t11 = <div className={mobileIconTileClass}>{t9}{t10}</div>;
    $[17] = mobileIconTileClass;
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const linkableContent = t11;
  const clickName = text || alt || "";
  let t12;
  if ($[21] !== clickName) {
    t12 = function onTileClicked(event) {
      tracker.navigationClick({
        click_name: clickName,
        click_position: "main_navi",
        click_url: event.currentTarget.href
      });
    };
    $[21] = clickName;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const onTileClicked = t12;
  let t13;
  if ($[23] !== link || $[24] !== linkableContent || $[25] !== onTileClicked) {
    t13 = link ? <LinkComponent link={link} onClick={onTileClicked}>{linkableContent}</LinkComponent> : linkableContent;
    $[23] = link;
    $[24] = linkableContent;
    $[25] = onTileClicked;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
}
export default memo(MobileIconTile);